<template>
  <LISAInput v-model="searchText" class="w-100" type="textarea" rows="1" />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { LISAInput } from "@fi-solutions/lisa-ui";
import DescriptionDraftFilter from "../filterImplementations/DescriptionDraftFilter";

const searchText = ref("");

function getFilter() {
  const value = searchText.value.trim();
  return value === "" ? null : new DescriptionDraftFilter(value);
}

function applyFilter(filter: DescriptionDraftFilter) {
  searchText.value = filter.searchText;
}

defineExpose({ getFilter, applyFilter });
</script>
